import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
  font-family: var(--font-barlow);

  .loading-container {
    display: flex;
    justify-content: center;
    padding: 40px;
  }

  .error-container {
    padding: 24px;
  }
`

export const BlockWrapper = styled.div<{ widthString: string }>`
  width: ${({ widthString }) => {
    switch (widthString) {
      case 'half':
        return '50%'
      case 'third':
        return '33.33%'
      case 'full':
      default:
        return '100%'
    }
  }};
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const TextBlockWrapper = styled.div`
  margin-block: 64px 32px;
  .title-text {
    line-height: 42px;
  }
  @media (max-width: 768px) {
    margin: var(--spacing-24) 16px;
    .title-text {
      font-size: 36px;
    }
  }
`

export const Title = styled.h2<{ size?: number; align?: string }>`
  font-size: ${({ size }) => (size ? `${size}px` : '24px')};
  text-align: ${({ align }) => align || 'left'};
  font-family: var(--font-barlow-semi-condensed);
  font-weight: 600;
  line-height: 30px;
  letter-spacing: 0.4px;
  margin-bottom: 0;
  color: var(--neutral-darkest);
`

export const Eyebrow = styled.div<{ align?: string }>`
  text-align: ${({ align }) => align || 'left'};
  color: #737370;
  font: normal 600 12px/18px var(--font-barlow);
  text-transform: uppercase;
  margin-bottom: var(--spacing-8);
  letter-spacing: 1.12px;
`

export const DescriptionText = styled.p<{ align?: string }>`
  font: 400 16px/160% var(--font-inter);
  color: #555;
  text-align: ${({ align }) => align || 'left'};
  margin-block: 20px 0;
`

export const MediaBlockWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  .media-video,
  .media-picture {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .media-image {
    width: 100%;
    height: auto;
    display: block;
  }
  @media (max-width: 768px) {
    margin-inline: var(--spacing-24);
  }
`

export const CardBlockWrapper = styled.div`
  padding: 32px 0;
  height: 100%;
  .carousel-header {
    margin-top: 32px;
  }
  .card-container {
    width: 100%;
    height: 100%;
    border-radius: 2px;
    overflow: hidden;
    background-color: white;
  }
  .card-cover {
    background-color: #f0f0f0;
    display: flex;
    justify-content: center;
  }
  .card-image {
    width: 100%;
    object-fit: cover;
  }
  .card-placeholder {
    height: 200px;
    background-color: #eaeaea;
  }
  .card-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }
  .card-title {
    margin: 0;
    font-size: 22px;
    font-family: var(--font-barlow-semi-condensed);
    color: var(--neutral-darkest);
    text-transform: capitalize;
  }
  .card-tag {
    margin-left: 12px;
    border-radius: 4px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    font-family: var(--font-barlow);
  }
  .card-description {
    margin: 0;
    margin-top: 12px;
    color: var(--neutral-body);
    font-family: var(--font-inter);
    font-size: 14px;
    line-height: 1.5;
  }
  .ant-divider {
    visibility: hidden;
  }
  @media (max-width: 768px) {
    padding: 18px 0;
    .carousel-header {
      padding-left: 24px;
    }
  }
`

export const CarouselBlockWrapper = styled.div`
  margin-block: 64px;
  height: 588px;
  .carousel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
  }

  .carousel-title {
    text-transform: capitalize;
  }

  .carousel-buttons {
    display: flex;
    gap: 16px;
  }

  .ant-btn-circle:hover {
    background: var(--neutral-darkest);
    border-color: var(--neutral-darkest);
    color: var(--neutral-white);
  }

  .carousel-track {
    display: flex;
    gap: 16px;
    overflow-x: auto;
    width: 100vw;
    position: absolute;
    left: 0;
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  }

  .carousel-card {
    position: relative;
    overflow: hidden;
    height: 500px;
    background-color: #eaeaea;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    border-radius: 8px;
    scroll-snap-align: start;
    cursor: pointer;
    &:first-child {
      margin-left: max(4.5rem, calc((100vw - 1296px) / 2));
    }
    &:last-child {
      margin-right: max(4.5rem, calc((100vw - 1296px) / 2));
    }
    @media (max-width: 768px) {
      &:first-child {
        margin-left: max(1.5rem, 3vw);
      }
      &:last-child {
        margin-right: max(1.5rem, 3vw);
      }
    }
  }

  .carousel-card.portrait {
    width: 400px;
  }

  .carousel-card.landscape {
    width: 833px;
  }

  @media (max-width: 768px) {
    height: 430px;
    .carousel-track {
      width: 100%;
      margin-left: 0;
    }
    .carousel-title {
      padding-left: 24px;
      font-size: 40px;
    }
    .carousel-buttons {
      display: none;
    }
    .carousel-card.portrait {
      width: 274px;
      max-height: 342px;
    }
    .carousel-card.landscape {
      width: 514px;
      max-height: 342px;
    }
  }

  .carousel-media {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    transition: opacity 0.3s ease;
  }

  .carousel-media.hover-media {
    opacity: 0;
  }

  .carousel-card:hover .carousel-media.hover-media {
    opacity: 1;
  }

  .carousel-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 40px 24px 24px;
    background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 10;
  }

  .carousel-card:hover .carousel-overlay {
    opacity: 1;
  }

  .carousel-label {
    margin: 0 0 4px 0;
    font-size: 16px;
    font-family: var(--font-barlow);
    font-weight: 600;
    color: #fff;
  }

  .carousel-description {
    margin: 0 0 16px 0;
    font-size: 13px;
    font-family: var(--font-inter);
    color: #eee;
  }

  .carousel-link {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    color: #fff;
    letter-spacing: 1px;
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
    transition: opacity 0.2s ease;
  }

  .carousel-link:hover {
    opacity: 0.8;
    color: #fff;
  }
`

export const ListBlockWrapper = styled.div`
  padding: 40px;
  border: var(--border-regular) solid var(--neutral-border-light);
  background: var(--neutral-white);
  margin: 32px 8px;
  flex: 1;
  div:has(> &) {
    display: flex;
    flex-flow: column;
  }
  .list-header {
    margin-bottom: 16px;
    letter-spacing: 0.38px;
  }
  .list-divider {
    width: 32px;
    height: 2px;
    background-color: var(--neutral-darkest);
    margin-top: 16px;
  }
  .list-ul {
    list-style-type: disc;
    padding-left: 20px;
    margin: 0;
    color: var(--neutral-body, #4A4A48);
    font: normal 400 14px/22px var(--font-inter);
  }
  .list-li {
    margin-bottom: 8px;
    line-height: 1.5;
    &:last-child {
      margin-bottom: 0;
    }
  }
  @media (max-width: 768px) {
    padding: 24px 16px;
    margin-block: var(--spacing-24) 8px;
    margin-inline: var(--spacing-24);
  }
`

export const CompositionBlockWrapper = styled.div`
  padding: 40px;
  border: var(--border-regular) solid var(--neutral-border-light);
  background: var(--neutral-white);
  margin: 32px 8px;
  flex: 1;
  div:has(> &) {
    display: flex;
    flex-flow: column;
  }
  .composition-header {
    margin-bottom: 16px;
    letter-spacing: 0.38px;
  }
  .composition-divider {
    width: 32px;
    height: 2px;
    background-color: var(--neutral-darkest);
    margin-top: 16px;
  }
  .composition-list {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-24);
  }
  .composition-item {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .composition-label {
    font: 600 14px/24px var(--font-barlow);
    color: var(--neutral-darkest);
  }
  .composition-text {
    font: 400 12px/20px var(--font-inter);
    color: var(--neutral-body);
  }
  @media (max-width: 768px) {
    padding: 24px 16px;
    margin-block: var(--spacing-24) 8px;
    margin-inline: var(--spacing-24);
  }
`

export const ScalesBlockWrapper = styled.div`
  padding: 40px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  margin: 32px 8px;
  flex: 1;
  div:has(> &) {
    display: flex;
    flex-flow: column;
  }
  .scales-header {
    margin-bottom: 16px;
    letter-spacing: 0.38px;
  }
  .scales-divider {
    width: 32px;
    height: 2px;
    margin-top: 16px;
    background-color: var(--neutral-darkest);
  }
  .scale-row {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .scale-label {
    margin: 0 0 8px 0;
    font: 600 14px/24px var(--font-barlow);
    color: var(--neutral-darkest);
  }
  .scale-ticks-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .scale-tick-highlighted {
    width: 2px;
    height: 16px;
    background-color: var(--neutral-darkest);
  }
  .scale-tick-normal {
    width: 2px;
    height: 10px;
    background-color: #ededeb;
  }
  .scale-ranges-container {
    display: flex;
    justify-content: space-between;
  }
  .scale-range-text {
    font: 400 12px/20px var(--font-inter);
    color: var(--neutral-body);
  }
  @media (max-width: 768px) {
    padding: 24px 16px;
    margin-block: var(--spacing-24) 8px;
    margin-inline: var(--spacing-24);
  }
`

export const RatingsBlockWrapper = styled.div`
  padding: 40px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  margin: 32px 8px;
  flex: 1;
  div:has(> &) {
    display: flex;
    flex-flow: column;
  }
  .ratings-header {
    margin-bottom: 16px;
    letter-spacing: 0.38px;
  }
  .ratings-divider {
    width: 32px;
    height: 2px;
    margin-top: 16px;
    background-color: var(--neutral-darkest);
  }
  .rating-row {
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .rating-labels-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: -4px;
  }
  .rating-label {
    font: 600 14px/24px var(--font-barlow);
    color: var(--neutral-darkest);
  }
  .rating-score {
    font: 400 14px/24px var(--font-inter);
    color: var(--neutral-darkest);
  }
  .rating-progress {
    margin: 0;
    .ant-progress-bg {
      background-color: var(--neutral-body) !important;
    }
  }
  @media (max-width: 768px) {
    padding: 24px 16px;
    margin-block: var(--spacing-24) 8px;
    margin-inline: var(--spacing-24);
  }
`

export const RelatedStoreItems = styled.div`
  margin-top: var(--spacing-32);
  height: 630px;
  .paginator {
    display: none;
  }
  li[data-isv2="true"] {
    border: var(--border-regular) solid var(--neutral-border-light);
    &:first-child {
      margin-left: max(4.5rem, calc((100vw - 1296px) / 2));
    }
    &:last-child {
      margin-right: max(4.5rem, calc((100vw - 1296px) / 2));
    }
    @media (max-width: 768px) {
      width: 264px;
      min-width: 264px;
      &:first-child {
        margin-left: max(1.5rem, 3vw);
      }
      &:last-child {
        margin-right: max(1.5rem, 3vw);
      }
      section {
        display: block;
      }
      .image-section {
        max-width: 100%;
      }
      .page-thumbnail {
        height: 334px;
      }
    }
  }
  #designs-list {
    overflow-x: auto;
    width: 100vw;
    position: absolute;
    left: 0;
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  }
  @media (max-width: 768px) {
    margin-top: 0;
    height: 600px;
    .priceLabel {
      white-space: nowrap;
    }
  }
`

export const RelatedDesigns = styled.div`
  margin-top: var(--spacing-40);
  @media (max-width: 768px) {
    margin-top: 30px;
    .design-item {
      max-width: 264px;
      min-width: 264px;
      section {
        display: block;
        width: 100%
      }
      .image-section {
        max-width: 100%;
      }
      .page-thumbnail {
        height: 334px;
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductSpecs/styledComponents.ts